import React from 'react';
import { List } from '@mui/material';
import { IEvent } from '~/Models/DTO/Event.model';
import { useStyles } from './CalendarList.styles';
import { CalendarDatePicker } from '~/Screens/Calendar/CalendarDatePicker';
import { CalendarListItem } from '~/Screens/Calendar/CalendarList/CalendarListItem';
import { differenceInMinutes } from 'date-fns';
import { CalendarListItemSkeleton } from './CalendarListItem/CalendarListItemSkeleton';

const getBreakTime = (events: IEvent[], index: number) => {
  const currentEvent = events[index];
  const nextEvent = events[index + 1];

  if (!nextEvent) {
    return -1;
  }

  return differenceInMinutes(new Date(nextEvent.start), new Date(currentEvent.end));
};

interface CalendarProps {
  events: IEvent[];
  calendarController: any;
  onTodayClick: () => void;
  isEventsLoading: boolean;
}

export const CalendarList = ({
  events,
  calendarController,
  onTodayClick,
  isEventsLoading,
}: CalendarProps) => {
  const { classes } = useStyles();

  return (
    <div className={classes.CalendarListContainer}>
      <div className={classes.root}>
        <CalendarDatePicker calendarController={calendarController} onTodayClick={onTodayClick} />
        <div className={classes.eventListContainer}>
          <List disablePadding>
            {isEventsLoading && <CalendarListItemSkeleton />}
            {!isEventsLoading &&
              events &&
              events.map((event: IEvent, index: number) => (
                <CalendarListItem
                  breakTime={getBreakTime(events, index)}
                  event={event}
                  key={index}
                />
              ))}
          </List>
        </div>
      </div>
    </div>
  );
};
